//todo: перенести в папку helpers
export function onReady(fn){
  // uninitialized - Has not started loading yet
  // loading - Is loading
  // loaded - Has been loaded
  // interactive - Has loaded enough and the user can interact with it
  // complete - Fully loaded
  if (document.readyState != 'loading'){
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}

// когда весь контент загружен
export function onLoaded(fn){
  let interval = setInterval(function() {
    if(document.readyState === 'complete') {
      clearInterval(interval);
      fn();
    }
  }, 100);
}

export function forceRedraw(element) {
  //Использовать один раз перед добавлением/удалением css класса/свойства, которое уже было только-что тронуто.
  //https://stackoverflow.com/questions/8840580/force-dom-redraw-refresh-on-chrome-mac
  //Доделал сам. Хуй знает как оно завелось, но как-то завелось.
  //offsetHeight приходится дергать 3 раза, иначе не пашет.
  element.offsetHeight
  var disp = element.style.display;
  element.style.display = 'none';
  var trick = element.offsetHeight;
  element.style.display = disp;
  element.offsetHeight
};



// WEBPACK FOOTER //
// ./src/helpers/helpers.js